'use strict';

module.exports.getDigitReader = function (options) {
  if(options && options.runInChildProcess){
    return require('./digitreader-master.js');
  } else {
    return require('./digitreader.js');
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/digitreader/index.js
// module id = 292
// module chunks = 0